export default __webpack_public_path__ + "static/engin-7dda66fbcd61d7a7f68536ab14f07fe7.jpg";